<template>
  <div class="prog_sec_cont">
    <div class="list_vertical">
      <ul class="list_vertical_ul">
        <li
          class="list_vertical_li"
          v-for="(item, index) in list"
          :key="index"
          :id="`list_${index}`"
        >
          <div class="top">
            <div
              class="tag"
              :class="{ best: index === 0 }"
              v-if="index < 3 && promotionCode != 'KT2408'"
            >
              <p>{{ index + 1 }}등</p>
            </div>
            <div class="profile_area" @click="goShopDetail(item.storeId)">
              <div class="profile_image">
                <div class="thumb_image">
                  <div class="thumb_image_inner">
                    <img
                      v-if="item.store.storeProfile"
                      :src="item.store.storeProfile"
                      alt=""
                    />
                    <img
                      v-else
                      :src="
                        setShopProfileImg(item.store.storeName, item.storeId)
                      "
                      alt=""
                    />
                    <img
                      v-if="item.store.cert === 1"
                      :src="
                        require('@/assets/front/images/v2/etc/icon_consent_m.png')
                      "
                      alt=""
                      class="consent"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="txt_area">
              <h1 class="store_name">{{ item.store.storeName }}</h1>
              <div class="store_info">
                <dl>
                  <dt>인터넷 개통</dt>
                  <dd>{{ item.store.internetSaleCnt }}건</dd>
                </dl>
                <dl>
                  <dt>
                    <img
                      :src="
                        require('@/assets/front/images/v2/icons/ic_star_on.svg')
                      "
                    />
                  </dt>
                  <dd @click.stop="moreReview(item.storeId)">
                    {{ Number(item.store.evaluationScore).toFixed(1) }}({{
                      item.store.reviewCnt
                    }}건)
                  </dd>
                </dl>
              </div>
            </div>
            <button
              class="btn_chat closed"
              v-if="
                isCounselClosed(
                  item.store.counselDay,
                  item.store.counselStart,
                  item.store.counselEnd,
                )
              "
            >
              휴무
            </button>
            <button
              class="btn_chat"
              v-else-if="item.chat == 0"
              @click="internetCommerceChat(index, item.chat)"
            >
              상담하기
            </button>
            <button
              class="btn_chat ing"
              v-else-if="item.chat > 0"
              @click="enterChatRoom(item.storeId, item.chat)"
            >
              상담 중
            </button>
            <!--휴뮤 closed, 상담중일때 ing-->
          </div>
          <div class="btm">
            <div class="date_guaranteed">
              <div class="create_date">{{ getCreateAt(item.createdAt) }}</div>
              <div
                v-if="item.store.internetGuaranteed > 0"
                class="store_guaranteed"
              >
                <img
                  :src="require('@/assets/front/images/v2/tag_guarantee.png')"
                  alt=""
                />
              </div>
              <div
                v-if="item.store.internetSupportType == 'SAME_DAY'"
                class="store_support_type"
              >
                <img
                  :src="require('@/assets/front/images/v2/tag_daypayment.png')"
                  alt=""
                />
              </div>
            </div>
            <div class="price_info">
              <ul>
                <li>
                  <dl>
                    <dt>통신사</dt>
                    <dd>{{ item.telecom }}</dd>
                  </dl>
                </li>
                <li>
                  <dl>
                    <dt>월 요금</dt>
                    <dd>{{ item.monthPrice | comma }}원</dd>
                  </dl>
                </li>
                <li v-if="promotionCode == 'KT2408'">
                  <dl>
                    <dt>총 혜택</dt>
                    <dd>{{ getTotalPrice(item) | comma }}원</dd>
                  </dl>
                </li>
                <li v-else>
                  <dl>
                    <dt>지원금</dt>
                    <dd>
                      {{
                        (item.cashSupport +
                          item.giftCardSupport +
                          item.giftItemSupport)
                          | comma
                      }}원
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
            <div class="more_info" :id="`more_info_${index}`">
              <div v-if="promotionCode == 'KT2408'">
                <div class="price_detail">
                  <p>
                    요금할인(퍼스특별)
                    {{ getPromotionSupportPrice(item) | comma }}원 + 상품권
                    {{ getPromotionGiftPrice(item) | comma }}원
                  </p>
                </div>
              </div>
              <div v-else>
                <div
                  class="price_detail"
                  v-if="item.cashSupport || item.giftCardSupport"
                >
                  <p v-if="item.cashSupport && item.giftCardSupport">
                    현금 {{ item.cashSupport | comma }}원 + 상품권
                    {{ item.giftCardSupport | comma }}원
                  </p>
                  <p v-if="item.cashSupport && item.giftCardSupport == 0">
                    현금 {{ item.cashSupport | comma }}원
                  </p>
                  <p v-if="item.cashSupport == 0 && item.giftCardSupport">
                    상품권
                    {{ item.giftCardSupport | comma }}원
                  </p>
                </div>
                <div class="item_in_tv">
                  <div class="item_in" v-if="item.itemInternet">
                    <div class="txt_1">{{ getSpeed(item) }} 인터넷</div>
                    <div class="txt_2">{{ item.itemInternet }}</div>
                  </div>
                  <div class="item_tv" v-if="item.itemTv">
                    <div class="txt_1">
                      {{ item.channel ? item.channel + 'ch' : '' }} TV
                    </div>
                    <div class="txt_2">{{ item.itemTv }}</div>
                  </div>
                </div>
              </div>
              <div
                class="info_1"
                :class="{ bb: item.memoSupport }"
                v-if="promotionCode != 'KT2408'"
              >
                <div v-if="item.cashRewardDate">
                  * 지원금 {{ item.cashRewardDate }}지급<span
                    v-if="item.giftcardSendDate != '해당없음'"
                    >(상품권 {{ item.giftcardSendDate }} 지급)</span
                  >
                </div>
                <div v-if="item.contractMonth">
                  * 가입요금제 최소 {{ item.contractMonth }}개월
                  유지조건(3년약정)
                </div>
                <div v-if="item.usageMonth">
                  * {{ item.usageMonth }}개월 이내 해지 시 지원금 전액 환수 및
                  위약금 발생
                </div>
                <div v-if="item.installCost">
                  * 설치비 별도: 주중
                  {{ item.installCost | comma }}원
                  <span v-if="item.installCostWeekend"
                    >주말·야간 {{ item.installCostWeekend | comma }}원</span
                  >
                </div>
                <div>
                  * {{ item.item
                  }}<span v-if="item.phoneTogether == 'PHONE'">+휴대폰</span
                  ><span v-else-if="item.phoneTogether == 'USIM'">+USIM</span>
                </div>
              </div>
              <div class="info_detail" v-if="item.memoSupport">
                <p v-html="$options.filters.nl2br(item.memoSupport)"></p>
              </div>
            </div>
            <div class="btn_more">
              <button
                :id="`btn_detail_${index}`"
                class="btn_detail"
                @click="showDetailView(index)"
              >
                <!--more_info가 열릴 때 on-->
                <img
                  :src="
                    require('@/assets/front/images/v2/arrows/ar_select_main_b.svg')
                  "
                />
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import promotionCfg from '@common/lib/common/promotionCfg';
export default {
  props: {
    list: Array,
    promotionCode: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {};
  },
  async created() {},
  computed: {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '20');

      return path;
    },
    showDetailView(index, type = '') {
      if (type == 'move') {
        var btnDetailElement = document.querySelector('.btn_detail.on');

        if (btnDetailElement != null) {
          btnDetailElement.classList.remove('on');
        }

        var moreInfoElement = document.querySelector('.more_info.on');

        if (moreInfoElement != null) {
          moreInfoElement.classList.remove('on');
        }
      }
      var btnSomeElement = document.getElementById(`btn_detail_${index}`);
      btnSomeElement.classList.toggle('on');

      var infoSomeElement = document.getElementById(`more_info_${index}`);
      infoSomeElement.classList.toggle('on');
    },
    isCounselClosed(counselDay, counselStart, counselEnd) {
      let now = new Date();
      var week = new Array('7', '1', '2', '3', '4', '5', '6'); // 일, 월, 화, 수, 목, 금, 토

      let hours = now.getHours(); // 시
      let minutes = now.getMinutes(); // 분

      var startTime = counselStart.split(':');
      var endTime = counselEnd.split(':');

      // 있음, 영업함
      if (counselDay.indexOf(week[now.getDay()]) !== -1) {
        // 시간 확인
        if (parseInt(startTime[0]) <= hours && parseInt(endTime[0]) >= hours) {
          if (parseInt(endTime[1]) < minutes && parseInt(endTime[0]) == hours) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    setMoveList(index) {
      this.showDetailView(index, 'move');
      const location = document.querySelector(`#list_${index}`).offsetTop;
      return location;
    },
    setOpenList(index) {
      this.showDetailView(index, 'move');
    },
    internetCommerceChat(index, chatCnt) {
      // alert('index=' + index);
      this.$emit('internetCommerceChat', index, chatCnt);
    },
    enterChatRoom(storeId, chatCnt) {
      this.$emit('enterChatRoom', storeId, chatCnt);
    },
    goShopDetail(storeId) {
      this.$emit('goShopDetail', storeId);
    },
    moreReview(storeId) {
      this.$emit('moreReview', storeId);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy.MM.dd HH:mm');
    },
    getSpeed(item) {
      if (item.speed) {
        return item.speed;
      } else {
        const itemArr = item.item.split(' ');
        return itemArr[0];
      }
    },
    getTotalPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      let promotionInfo = promotionCfg.getPriceInfo(item.telecom, telecomItem);

      console.log(promotionInfo);
      return promotionInfo.support + promotionInfo.gift;
    },
    getPromotionSupportPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthSupportPrice(item.telecom, telecomItem);
    },
    getPromotionGiftPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthGiftPrice(item.telecom, telecomItem);
    },
    getPromotionItem(item) {
      let itemArr = '';
      let telecomItem = '';
      if (item.item == '100M 인터넷') {
        itemArr = item.item.split(' ');
        telecomItem = itemArr[0];
      } else {
        itemArr = item.item.split('+');
        if (itemArr[0].indexOf('100M') != -1) {
          telecomItem = '100M';
        } else if (itemArr[0].indexOf('500M') != -1) {
          telecomItem = '500M';
        }

        if (itemArr[1].indexOf('TV') != -1) {
          telecomItem += '+TV';
        }
      }
      return telecomItem;
    },
  },
};
</script>
